import Vue from "vue";

// "Afișare compactă" (user menu): lower table rows, a shorter header band and less space around things, for
// people who want more on the screen. Kept per device in localStorage; applied as a class on <html> so the
// rem-based sizes shrink with it (styles in theme.css, SideBar.vue, TopBar.vue).
const KEY = "ui.compact";

function stored() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch (error) {
    return false;
  }
}

export const display = Vue.observable({ compact: stored() });

function apply() {
  document.documentElement.classList.toggle("density-compact", display.compact);
}

export function setCompact(on) {
  display.compact = !!on;
  try {
    localStorage.setItem(KEY, display.compact ? "1" : "0");
  } catch (error) {
    // private mode / blocked storage: it still applies until the page is reloaded
  }
  apply();
}

apply();
